<script lang="ts" setup>
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'

export interface PagesBlogRelatedArticlesSliderProps {
    heading: string
    subtitle?: string
    headingLevel: HeadingLevel
    data: BlogPost[]
}

const props = defineProps<PagesBlogRelatedArticlesSliderProps>()
const sliderOptions = {
    pagination: true,
    arrows: true,
    gap: '3rem',
    drag: true,
    perPage: 3,
    breakpoints: {
        992: {
            drag: true,
            pagination: true,
            gap: '2rem',
            arrows: true,
        },
        768: {
            fixedWidth: '90%',
            perPage: 1,
            gap: '1rem',
        },
    },
}
</script>
<template>
  <Box
    decor-position="top-right"
    data-cy="related_articles"
  >
    <BoxHeader
      :heading-level="props.headingLevel"
      :subtitle="props.subtitle"
      :heading="props.heading"
    />
    <Slider :options="sliderOptions">
      <SplideSlide
        v-for="(slide, index) in data"
        :key="`wai-${index}`"
        :has-track="false"
      >
        <ArticleBox
          :data="slide"
          link-type="url"
          :target="slide.targetBlank"
        />
      </SplideSlide>
    </Slider>
  </Box>
</template>
